/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useState, useEffect } from "react";
import { getColumnsForQualityParameters } from "./columns";
import { FinalQualityParameter, ParameterEvaluation } from "../../../types/mediaFinalQuality.types";
import MediaPrepTable from "../../../../../common/commonComponents/lotDetailsTable";

interface Props {
	parameters: FinalQualityParameter[];
	evaluations: Record<string, ParameterEvaluation>;
	setEvaluations: React.Dispatch<React.SetStateAction<Record<string, ParameterEvaluation>>>;
	errors: Record<string, string>,
    setErrors: React.Dispatch<React.SetStateAction<Record<string, string>>>
}
const ParamsTable = ({ parameters, evaluations, setEvaluations, errors, setErrors }: Props) => {


	// Simulate fetching parameters
	useEffect(() => {
		// Only initialize if we have parameters and haven't set evaluations yet
		if (parameters.length > 0 && Object.keys(evaluations).length === 0) {
			const initialState: Record<string, ParameterEvaluation> = {};
			parameters.forEach((p) => {
				initialState[p.id] = { parameter_id: p.id, pass_flag: true };
			});
			setEvaluations(initialState);
		}
	}, [parameters]); // Added dependency here

	const handleStatusChange = (id: string, pass_flag: boolean) => {
		setEvaluations((prev) => ({
			...prev,
			[id]: {
				...prev[id],
				parameter_id: id,
				pass_flag,
				// Reset count to undefined if it passes
				fail_count: pass_flag ? undefined : prev[id]?.fail_count,
			},
		}));
	};

	const handleCountChange = (id: string, count: number) => {
		setEvaluations((prev) => ({
			...prev,
			[id]: {
				...prev[id],
				parameter_id: id,
				fail_count: isNaN(count) ? 0 : count,
			},
		}));
	};

	const handleSubmit = () => {
		// Construct the final payload format
		const payload = {
			media_batch_id: 2, // Hardcoded per your example, make dynamic as needed
			parameters: Object.values(evaluations).map((evaluation) => ({
				parameter_id: parseInt(evaluation.parameter_id, 10),
				pass_flag: evaluation.pass_flag,
				// Only include fail_count if the flag is false
				...(evaluation.pass_flag === false && {
					fail_count: evaluation.fail_count || 0,
				}),
			})),
			remarks: "Quality review completed.",
		};

		console.log("Submitting:", JSON.stringify(payload, null, 2));
	};

	const columns = getColumnsForQualityParameters(
		evaluations,
		handleStatusChange,
		handleCountChange,
		errors,
    	setErrors
	);

	return (
		<div>
			<MediaPrepTable
				columns={columns}
				data={parameters}
				emptyMessage="No quality parameters configured."
			/>
		</div>
	);
};

export default ParamsTable;
